const authorityInvoicesStyle = {
  buttonContainer: {
    padding: "1rem 0",
    textAlign: "center",
  },
};

export default authorityInvoicesStyle;
